import React, { useCallback, useEffect, useState } from "react";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { isEmptyDash, returnRateVal, strToDate,trimString } from "../../constant";
import AlertComponent from "../alert/alert";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Filter from "../filter/filter";
import TrackOrder from "./trackOrder";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";


const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  marginTop: "5rem",
};

function TableListingWithoutDnD(props) {
  const [opencreateentry, setOpenCreateEntry] = useState(false);
  const [columns, setColumns] = useState(props?.column);
  const [isRequestModalOpen, setIsRequestModalOpen] = React.useState(false);

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [listing, setListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    [props?.listingArrName]: [],
  });
  const [selectedListItemArr, setSelectedListItemArr] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  
  const [inputPage, setInputPage] = useState(listing?.currentPage || 1);
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [selectedModalObj, setSelectedModalObj] = useState({});

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= listing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(listing?.currentPage);
      }
    }
  };
  
  useEffect(() => {
    getListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    
    if (props?.additionalData?.isMaster == true) {
        param += `&type=${props?.additionalData?.type}`;
    }
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = "";
    if (props?.promiseUrlType == "DETAILS") {
      promise = props?.promiseRequest(props?.detailsId, param);
    }
    if (props?.promiseUrlType == "LIST") {
      promise = props?.promiseRequest(param);
    }
    promise.then((res) => {
      if (res.data.success === true) {
        setListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const redirectToDetails = (path) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: props?.componentName,
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(path);
  };

  const handleRequestModalOpen = (row, column, index) => {
    console.log(row, column, index);    
    setSelectedModalObj({ header: column?.label, text: JSON.stringify(row[column?.id])});
    setIsRequestModalOpen(true);
  };

  const handleRequestModalClose = () => { setIsRequestModalOpen(false); setIsRequestModalOpen(''); }

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
      // console.log("Debounce: ", searchTerm);

    }, 800),
    []
  );

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        // console.log(i, sortBy, sortOrder);
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
    // console.log(requestPayloadInit, columnsInit, index);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  const handleFilterFormSubmit = (formDataa) => {
    // console.log('formDataaformDataaformDataa', formDataa);
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getListing(updatedPayload, filterText, formDataa || '');
  };

  const [selectPOId, setSelectedPOId] = useState('');
  const [trackOrderData, setTrackOrderData] = useState("");

  const handleResetFormSubmit = () => {
    getListing(requestPayload, filterText, {});
  }

  const onListCheckChange = (value, row, rowIndex) => {
    let listingInit = _.cloneDeep(listing);
    listingInit[props?.listingArrName][rowIndex].isChecked = value;
    let arr = [];
    let purchaseOrderID = [];
    for (let i = 0; i < listingInit[props?.listingArrName].length; i++) {
      if (listingInit[props?.listingArrName][i].isChecked == true) {
        arr.push(listingInit[props?.listingArrName][i]._id);
        purchaseOrderID.push(listingInit[props?.listingArrName][i].purchaseOrderIds);
      }
    }
    // console.log(value, listingInit, arr, rowIndex);  
    setSelectedListItemArr(arr);
    setListing(listingInit);
    setSelectedPOId(purchaseOrderID);
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  
  const handleTrackOrder = () => {
    if (selectedPOArr.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select atleast one Purchase Order. ` });
      return;
    }
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(selectedPOArr)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );
  
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="master_main_row_1">
            <div className="search_filter_outers ms-auto">
            {(props?.additionalData?.isSearch == true) && <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                      
                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>}
              
              <div className="price_modification_secondarybtn">
                
                {(props?.additionalData?.is_CREATE_PRICE_MOD_REQ == true) && <div className="bpdt_po_order_react">
                      <div>
                        <button className="btn btn-outline-secondary" onClick={() => navigateUrl(`/admin/po-price-modification-creation`)}> 
                          Create Price Modification
                        </button>
                      </div>
                    </div>}
                    
                {(props?.additionalData?.is_CREATE_QUANTITY_MOD_REQ == true) && <div className="bpdt_po_order_react">
                      <div>
                        <button className="btn btn-outline-secondary" onClick={() => navigateUrl(`/admin/po-qty-modification-creation`)}> 
                          Create QTY Modification
                        </button>
                      </div>
                    </div>}

                    {(props?.additionalData?.isTrackOrder == true) && <div>
                      <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>
                      <Drawer
                        anchor="right"
                        open={state.open}
                        onClose={toggleDrawer(false)}
                        style={{ zIndex: 99999 }}
                      >
                        {DrawerList}
                      </Drawer>
                    </div>}

                    {(props?.additionalData?.isFilter == true) && <div className="btn btn-outline-secondary">               
                      <div className="lets_filter_vendorlist_body_detail">
                        <FilterAltIcon />
                        <Filter uniqueName={props?.filterKeyName} formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                      </div>
                    </div>}
              </div>                
            </div>

            <table>
                <thead>
                  <tr>
                    
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels"   >
                        {column.label}
                        {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                        </span>}
                        </th>
                  </>))}

                    {/* <th className="vendor_tabels">S.NO</th>
                    <th className="vendor_tabels">Vendors Name</th>
                    <th className="vendor_tabels">Company Name</th>
                    <th className="vendor_tabels">Location</th>
                    <th className="vendor_tabels">Item Description</th>
                    <th className="vendor_tabels">Quantity</th>
                    <th className="vendor_tabels">Date & Time</th>
                    <th className="vendor_tabels">Amount</th>
                    <th className="vendor_tabels">Status</th>
                    <th className="vendor_tabels">Action</th> */}
                    
                  </tr>
                </thead>
                <tbody>
                    
                    {listing[props?.listingArrName].length < 1 && <>
                        <tr>
                          <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      
                      {listing[props?.listingArrName]?.map((row, rowIndex) => (
                        <tr key={rowIndex} className="maine_tr_vendor">
                          {/* <td>
                            <input type="checkbox"
                              checked={row.isChecked} onChange={(e) => onListCheckChange(e.target.checked, row, rowIndex)}
                            />
                          </td> */}
                          {columns.map((column, index) => (
                            <>
                              {(column.isRedirect == true) ? (<td>
                                <p className="list-details-para" onClick={() => redirectToDetails(`${column.redirectUrl}/${row[column?.redirectKeyName]}`)}>
                                  {row[column.id]}
                                </p>
                              </td>) : (column.id == "index") ? (<td>
                                <p  >
                                  {rowIndex + 1}
                                </p>
                              </td>) : column.id === "rfqValidity.from" ? (
                                  <td>{row.rfqValidity?.from ? strToDate(row.rfqValidity.from) : "N/A"}</td>
                                ) : column.id === "rfqValidity.to" ? (
                                  <td>{row.rfqValidity?.to ? strToDate(row.rfqValidity.to) : "N/A"}</td>
                                ) : (column.formate == "DATE") ? (<td>
                                <p  >
                                  {isEmptyDash(row[column.id]) ? "N/A" : strToDate(row[column.id])}
                                </p>
                              </td>) : (column.formate == "MODAL_TEXTAREA") ? (<td>                                
                                <Button onClick={() => handleRequestModalOpen(row, column, index)}>
                                  View
                                </Button>
                              </td>)  : (column.formate == "RATE") ? (<td>                                
                                <p  >
                                  {returnRateVal(row[column.id])}
                                </p>
                              </td>) : (column.formate == "Redirect_Btn") ? (<td>                                
                                <button className="view_dpbt_row_btn_detail_rowq" onClick={() => redirectToDetails(`${column.redirectUrl}/${row[column?.redirectKeyName]}`)}>
                                    View Detail
                                </button>
                              </td>) :
                                <td key={index} >
                                  {/* {row[column.id] || "N/A"} */}
                                     <Tooltip title={row[column.id] || "N/A"}>
                                    {trimString(row[column.id], 20 || "N/A")}
                                    </Tooltip>
                                </td>
                              }
                            </>
                          ))}
                        </tr>
                      ))}
                  {/* <tr>
                    <td>1</td>
                    <td>XYZ Industries</td>
                    <td>Orance Pvt. Ltd.</td>
                    <td>Delhi</td>
                    <td>Solar Panels</td>
                    <td>2</td>
                    <td>4-6-2024 : 12:30</td>
                    <td>₹ 12000</td>
                    <td className="reject_row_color">Rejected</td>
                    <td>
                      <button className="view_dpbt_row_btn_detail_rowq">
                        View Detail
                      </button>
                    </td>
                  </tr> */}
                </tbody>
              </table>
                
          {(props?.additionalData?.isPagination) && <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(listing?.pageSize) * Number(listing?.currentPage - 1) + 1} to ${Number(listing?.pageSize) * Number(listing?.currentPage - 1) + Number(listing[props?.listingArrName]?.length)} of ${listing?.totalItems}`}
              </span>
            </div>

            <Stack spacing={2}>
              <Pagination
                count={listing?.totalPages}
                page={listing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === listing?.currentPage) {
                    return (
                      <input
                        className="form-control form-hasw"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
                
              />
            </Stack>
          </div>}
          </div>
        </div>
      </div>
      
      <Modal
            open={isRequestModalOpen}
            onClose={handleRequestModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      {selectedModalObj?.header}
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      fdprocessedid="kum8iho"
                      onClick={handleRequestModalClose}
                    ></button>
                  </div>
                  <div class="modal-body vrf-h-flow" style={{ height: "190px", textAlign: "left", paddingTop: "21px" }}>
                    <div class="vendor_registration_form ">
                      <div>
                      {selectedModalObj?.text}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    </>
  )
}

export default TableListingWithoutDnD